import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../ui/button";
import { hasOohAccess } from "../navSections";
import { Moon } from "@phosphor-icons/react";

/** "Out of hours? Log it on the OOH desk" — shown beside New Request while the desk is active, to OOH users only. */
export default function OohNewRequestLink() {
  const { user } = useAuth();
  const [active, setActive] = useState(false);
  const allowed = hasOohAccess(user);
  useEffect(() => {
    if (!allowed) return;
    API.get("/ooh/status").then(({ data }) => setActive(!!data.active)).catch(() => {});
  }, [allowed]);
  if (!allowed || !active) return null;
  return (
    <Button asChild variant="outline" className="border-indigo-400 text-indigo-700 hover:bg-indigo-50 dark:text-indigo-300" data-testid="jr-ooh-link">
      <Link to="/ooh?new=1" title="The out of hours desk is active — log it there so it gets the AI triage and the 08:00 handover"><Moon size={16} weight="fill" className="mr-1" /> Out of hours? Log it on the OOH desk</Link>
    </Button>
  );
}
